import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import React, { Component } from "react";
import Utils from "../../../provider/Utils";
import store from "../../../redux/store";
import DeleteButton from "../../givBee/buttons/DeleteButton";
import EditButton from "../../givBee/buttons/EditButton";
import "./AdminRegistrationNote.css";
export default class AdminRegistrationNote extends Component {
  header = store.getState().header.header;
  noteListRef = [];
  constructor(props) {
    super(props);
    let action = props.action;
    let note = props.data;

    this.state = {
      id: note.id,
      note: note.note,
      time: note.dateTime,
      index: props.srno,
      operation: note.operation,
      onDelete: props.onDelete,
      onNoteEdit: props.onNoteEdit,
      onNoteDelete: props.onNoteDelete,
      onNoteUpdate: props.onNoteUpdate,
      onNoteMsg: props.onNoteMsg,
      addNote: props.addNote,
      action: action,
      render: true,
    };
  }

  //   componentWillUnmount() {
  //     this.unsubscribe();
  //   }

  addNote(e) {
    if (this.state.addNote) {
      this.setState({ action: "view" });
      this.state.addNote(this.state);
    }
  }

  handleDescriptionChange(e) {
    let val = e.target.value;
    let res = val.substring(0, 2048);
    if (res.length < 2048) {
      this.setState({ note: res });
    } else {
      Utils.maxFieldLength(2048);
    }
  }

  accountNoteRemove(e) {
    if (undefined !== this.state.onDelete && null !== this.state.onDelete) {
      this.state.onDelete(this.state);
    }
  }

  editNote(e, id) {
    this.setState({ action: "edit", render: true });
  }

  updateAccountNotes(e) {
    if (
      undefined !== this.state.onNoteUpdate &&
      null !== this.state.onNoteUpdate
    ) {
      this.state.onNoteUpdate(this.state);
      this.setState({ action: "view" });
    }
  }

  deleteAccountNote(e, id) {
    this.setState({ id: id });
    if (
      undefined !== this.state.onNoteDelete &&
      null !== this.state.onNoteDelete
    ) {
      this.state.onNoteDelete(this.state);
    }
  }

  backToViewAction() {
    this.setState({ action: "view" });
  }

  render() {
    this.noteListRef = React.createRef();
    if (this.state.render === false) {
      return "";
    }
    if (this.state.action === "create") {
      return this.createAccountNote();
    } else if (this.state.action === "edit") {
      return this.editAccountNote();
    } else {
      return this.viewAccountNote();
    }
  }

  createAccountNote() {
    return (
      <div
        className="card"
        id="organizationFormCard"
        style={{
          backgroundColor: "#fcf3cf",
          marginBottom: " 1em !important",
        }}
      >
        <div className="card-body">
          {/* <div className="row" style={{ padding: "10px" }}> */}
          <div className="col-md-12">
            <TextareaAutosize
              title=""
              aria-label="minimum height"
              style={{ width: "100%", padding: "10px" }}
              minRows={3}
              required
              id={"note" + this.state.index}
              value={this.state.note}
              name="note"
              inputprops={{ maxLength: 2048 }}
              onChange={this.handleDescriptionChange.bind(this)}
              // onPressEnter={this.handleDescriptionChange.bind(this)}
              placeholder="Enter Note Details"
            />
          </div>
          {/* </div> */}
          <div className="mt-2 text-center">
            <i
              className="fa fa-check"
              onClick={this.addNote.bind(this)}
              id="accountNoteButton"
              aria-hidden="true"
            ></i>
            &nbsp;
            <i
              className="fa fa-remove"
              onClick={this.accountNoteRemove.bind(this)}
              aria-hidden="true"
              id="accountNoteButton"
            ></i>
          </div>
        </div>
      </div>
    );
  }

  editAccountNote() {
    return (
      <div
        className="card"
        id="organizationFormCard"
        style={{
          backgroundColor: "#fcf3cf",
          marginBottom: " 1em !important",
        }}
      >
        <div className="card-body">
          {/* <div className="row" style={{ padding: "10px" }}> */}
          <div className="col-md-12">
            <TextareaAutosize
              title=""
              aria-label="minimum height"
              style={{ width: "100%", padding: "10px" }}
              minRows={3}
              required
              id={"note" + this.state.index}
              value={this.state.note}
              name="note"
              inputprops={{ maxLength: 2048 }}
              onChange={this.handleDescriptionChange.bind(this)}
              // onPressEnter={this.handleDescriptionChange.bind(this)}
              placeholder="Enter Note Details"
            />
          </div>
          {/* </div> */}
          <div className="mt-2 text-center">
            <i
              className="fa fa-check"
              onClick={this.updateAccountNotes.bind(this)}
              id="accountNoteButton"
              aria-hidden="true"
            ></i>
            &nbsp;
            <i
              className="fa fa-remove"
              onClick={this.backToViewAction.bind(this)}
              aria-hidden="true"
              id="accountNoteButton"
            ></i>
          </div>
        </div>
      </div>
    );
  }

  viewAccountNote() {
    return (
      <>
        <div
          className="card"
          id="organizationFormCard"
          style={{
            backgroundColor: "#fcf3cf",
            marginBottom: " 1em !important",
          }}
        >
          <div className="card-body" style={{ margin: "-12px 0px" }}>
            {/* <div className="row" style={{ padding: "10px" }}> */}
            <div className="row">
              <div className="col-md-9">
                <span style={{ color: "#566573", padding: "5px 3px" }}>
                  {/* <strong>{this.state.title}</strong> */}
                </span>
              </div>
              <div className="col-md-3 d-flex text-end">
                <EditButton
                  style={{
                    float: "right",
                    fontSize: "small",
                    height: "2em",
                    width: "2em",
                    background: "rgb(19, 98, 105)",
                    cursor: "pointer",
                    color: "white",
                    border: "2px solid #edf0f1",
                    borderRadius: "50%",
                    padding: "2px",
                  }}
                  onClick={(e) => this.editNote(e, this.props.data.id)}
                  id="iconButton"
                />
                <DeleteButton
                  domainObject="Account Note"
                  onClick={(e) => this.deleteAccountNote(e, this.props.data.id)}
                />
              </div>
            </div>
            <hr className="m-0 fw-bold"></hr>
            <div className="row">
              <p
                className="view_AppointmentNote"
                style={{
                  color: "#000",
                  padding: "9px 14px",
                  textAlign: "justify",
                  height: "5.6em",
                }}
              >
                {" "}
                {this.state.note}
              </p>
            </div>
            <hr className="m-0 fw-bold"></hr>
            <div
              className="row"
              style={{ display: "inline-flex", width: "100%" }}
            >
              <div className="col-md-12">
                <label
                  style={{
                    fontWeight: "600",
                    color: "#888888",
                    fontSize: "xx-small",
                    textAlign: "left",
                  }}
                  className="createdBy"
                >
                  {this.props.data.createdbyName &&
                    "Created by " + this.props.data.createdbyName}
                  {this.props.data.createdon &&
                    " on " +
                      Utils.getUtcToLocalDateTimeZone(this.props.data.createdon)}
                </label>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
